import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import Contractor from '../../components/people/contractor/Contractor'
import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { 
    getAlimentazioneBarca, getTipoAssicurazioneBarca, getTipoUtilizzoBarca, getLuoghi
} from '../../libs/initialization/remoteInits'

import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { ShipPageProps, ShipPageState, shipPageInitialState, shipUpdate } from './ShipPageSilce'

import ShipStepTwo from './ShipStepTwo'
import ShipStepThree from './ShipStepThree'
import * as ShipValidation from './ShipValidation'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class ShipPage extends BasePage<ShipPageProps, ShipPageState> {
    
    constructor (props: any) {
        super (props)

        this.state = {
            ...shipPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        this.updateTipo = this.updateTipo.bind(this)
        this.updateLunghezza = this.updateLunghezza.bind(this)
        this.updatePeso = this.updatePeso.bind(this)
        this.updateTarga = this.updateTarga.bind(this)
        this.updateNome = this.updateNome.bind(this)
        this.updatePorto = this.updatePorto.bind(this)
        this.updateCostruttore = this.updateCostruttore.bind(this)
        this.updateTrasportati = this.updateTrasportati.bind(this)
        this.updateKw = this.updateKw.bind(this)
        this.updateCavalli = this.updateCavalli.bind(this)
        this.updateMatricola = this.updateMatricola.bind(this)
        this.updateAnno = this.updateAnno.bind(this)
        this.updateAlimentazione = this.updateAlimentazione.bind(this)
        this.updateMarca = this.updateMarca.bind(this)
        this.updateOrmeggio = this.updateOrmeggio.bind(this)
        this.updateUtilizzo = this.updateUtilizzo.bind(this)


        this.updateAlimentizioni = this.updateAlimentizioni.bind(this)
        this.updateTipologie = this.updateTipologie.bind(this)
        this.updateUtilizzi = this.updateUtilizzi.bind(this)
        this.updateLuoghi = this.updateLuoghi.bind(this)

        this.stepTwoValidation = this.stepTwoValidation.bind(this)
        this.stepThreeValidation = this.stepThreeValidation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.alimentazioni === undefined) {
            getAlimentazioneBarca (this.updateAlimentizioni, this.manageExpiredSessions)
        }
        if (this.state.utilizzi === undefined) {
            getTipoUtilizzoBarca (this.updateUtilizzi, this.manageExpiredSessions)
        }
        if (this.state.tipologie === undefined) {
            getTipoAssicurazioneBarca (this.updateTipologie, this.manageExpiredSessions)
        }
        if (this.state.luoghi === undefined) {
            getLuoghi (this.updateLuoghi, this.manageExpiredSessions)
        }
    }

    render(): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="smarthpone_form">
                                
                                <Pagination
                                    maxPagges={3}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={false}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={false}
                                        validatePage={this.stepTwoValidation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <ShipStepTwo 
                                            tipoPolizza={this.state.tipoPolizza}
                                            lunghezza={this.state.lunghezza}
                                            peso={this.state.peso}
                                            targa={this.state.targa}
                                            nome={this.state.nome}
                                            porto={this.state.porto}
                                            costruttore={this.state.costruttore}
                                            trasportati={this.state.trasportati}

                                            tipoPolizzaError={this.state.tipoPolizzaError}
                                            lunghezzaError={this.state.lunghezzaError}
                                            pesoError={this.state.pesoError}
                                            targaError={this.state.targaError}
                                            nomeError={this.state.nomeError}
                                            portoError={this.state.portoError}
                                            costruttoreError={this.state.costruttoreError}
                                            trasportatiError={this.state.trasportatiError}

                                            tipologie={this.state.tipologie}

                                            updateTipoCallBack={this.updateTipo}
                                            updateLunghezzaCallBack={this.updateLunghezza}
                                            updatePesoCallBack={this.updatePeso}
                                            updateTargaCallBack={this.updateTarga}
                                            updateNomeCallBack={this.updateNome}
                                            updatePortoCallBack={this.updatePorto}
                                            updateCostruttoreCallBack={this.updateCostruttore}
                                            updateTrasportatiCallBack={this.updateTrasportati}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 3}
                                        pageNumber={3}
                                        isLast={true}
                                        validatePage={this.stepThreeValidation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <ShipStepThree 
                                            kw={this.state.kw}
                                            cavalli={this.state.cavalli}
                                            matricola={this.state.matricola}
                                            anno={this.state.anno}
                                            alimentazione={this.state.alimentazione}
                                            marca={this.state.marca}
                                            ormeggio={this.state.ormeggio}
                                            utilizzo={this.state.utilizzo}

                                            noMotorPrivacy={this.state.noMotorPrivacy}

                                            utilizzi={this.state.utilizzi}
                                            alimentazioni={this.state.alimentazioni}
                                            luoghi={this.state.luoghi}

                                            user={this.state.user}

                                            kwError={this.state.kwError}
                                            cavalliError={this.state.cavalliError}
                                            matricolaError={this.state.matricolaError}
                                            annoError={this.state.annoError}
                                            alimentazioneError={this.state.alimentazioneError}
                                            marcaError={this.state.marcaError}
                                            ormeggioError={this.state.ormeggioError}
                                            utilizzoError={this.state.utilizzoError}
                                            noMotorPrivacyError={this.state.noMotorPrivacyError}

                                            updateKwCallBack={this.updateKw}
                                            updateCavalliCallBack={this.updateCavalli}
                                            updateMatricolaCallBack={this.updateMatricola}
                                            updateAnnoCallBack={this.updateAnno}
                                            updateAlimentazioneCallBack={this.updateAlimentazione}
                                            updateMarcaCallBack={this.updateMarca}
                                            updateOrmeggioCallBack={this.updateOrmeggio}
                                            updateUtilizzoCallBack={this.updateUtilizzo}
                                            updateNoMotorPrivacyCallBack={this.updateNoMotorPrivacy}
                                        />
                                    </SinglePage>
                                </Pagination>

                            </form>
                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />

                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return shipPageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {

        return Promise.all([
            this.step1Validation(),
            this.stepTwoValidation(),
            this.stepThreeValidation()
        ]).then ((responses) => {

            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            else if (responses[2] !== undefined) {
                p = 3
                e = responses[2]
            }
            
            return {
                errorString: e,
                pageError: p
            }

        }).catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        }
        else {
            let tipoPolizzaErro = undefined
            let lunghezzaErro = undefined
            let pesoErro = undefined
            let targaErro = undefined
            let nomeErro = undefined
            let portoErro = undefined
            let costruttoreErro = undefined
            let trasportatiErro = undefined

            let kwErro = undefined
            let cavalliErro = undefined
            let matricolaErro = undefined
            let annoErro = undefined
            let alimentazioneErro = undefined
            let marcaErro = undefined
            let ormeggioErro = undefined
            let utilizzoErro = undefined

            let noMotorPrivacyErro = undefined
            let global = undefined

            if ( errorString === 'TIPOPOLIZZA' ) {
                tipoPolizzaErro = 'Selezionare un valore'
                global = "Selezionare l'oggetto da assicurare"
            }
            else if ( errorString === 'LUNGHEZZA' ) {
                lunghezzaErro = 'Valore non valido'
                global = 'Indicare la lunghezza della barca'
            }
            else if ( errorString === 'PESO' ) {
                pesoErro = 'Valore non valido'
                global = 'Indicare il peso della barca'
            }
            else if ( errorString === 'TARGA' ) {
                targaErro = 'Valore non valido'
                global = 'Indicare la targa della barca'
            }
            else if ( errorString === 'NOME' ) {
                nomeErro = 'Valore non valido'
                global = nomeErro
            }
            else if ( errorString === 'PORTO' ) {
                portoErro = 'Valore non valido'
                global = 'Indicare il porto di stazionamento della barca'
            }
            else if ( errorString === 'COSTRUTTORE' ) {
                costruttoreErro = 'Valore non valido'
                global = 'Indicare il costruttore della barca'
            }
            else if ( errorString === 'TRASPORTATI' ) {
                trasportatiErro = 'Valore non valido'
                global = 'Indicare il numero dei trasportabili'
            }
            else if ( errorString === 'KW' ) {
                kwErro = 'Valore non valido'
                global = 'Indicare la potenza del motore'
            }
            else if ( errorString === 'CAVALLI' ) {
                cavalliErro = 'Valore non valido'
                global = 'Indicare i cavalli del motore'
            }
            else if ( errorString === 'MATRICOLA' ) {
                matricolaErro = 'Valore non valido'
                global = 'Indicare la matricola o il CIN'
            }
            else if ( errorString === 'ANNO' ) {
                annoErro = 'Valore non valido'
                global = "Indicare l'anno di costruzione del motore"
            }
            else if ( errorString === 'ALIMENTAZIONE' ) {
                alimentazioneErro = 'Valore non valido'
                global = 'Indicare il tipo di alimentazione del motore'
            }
            else if ( errorString === 'BRAND' ) {
                marcaErro = 'Valore non valido'
                global = 'Indicare la marca del motore'
            }
            else if ( errorString === 'ORMEGGIO' ) {
                ormeggioErro = 'Valore non valido'
                global = 'Indicare dove è ormeggiata la barca'
            }
            
            else if ( errorString === 'UTILIZZO' ) {
                utilizzoErro = 'Valore non valido'
                global = 'Selezionare il tipo di utilizzo'
            }
            else if ( errorString === 'TOKEN_EXPIRED' ) {
                global = 'Sessione scaduta, ti preghiamo di ri autenticarti'
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            }
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipoPolizzaError: tipoPolizzaErro,
                lunghezzaError: lunghezzaErro,
                pesoError: pesoErro,
                targaError: targaErro,
                nomeError: nomeErro,
                portoError: portoErro,
                costruttoreError: costruttoreErro,
                trasportatiError: trasportatiErro,

                kwError: kwErro,
                cavalliError: cavalliErro,
                matricolaError: matricolaErro,
                annoError: annoErro,
                alimentazioneError: alimentazioneErro,
                marcaError: marcaErro,
                ormeggioError: ormeggioErro,
                utilizzoError: utilizzoErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        const isSoloMotore = this.state.tipoPolizza === 'soloMotore'

        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            Boat_Category: this.state.tipoPolizza ?? null,
            Boat_Length: (isSoloMotore) ? null : (this.state.lunghezza ?? null),
            Boat_Weight: (isSoloMotore) ? null : (this.state.peso ?? null),
            Boat_Plate: (isSoloMotore) ? null : (this.state.targa ?? null),
            Boat_Name: (isSoloMotore) ? null : (this.state.nome ?? null),
            Boat_Station_Port: (isSoloMotore) ? null : (this.state.porto ?? null),
            Boat_Builder_Name: (isSoloMotore) ? null : (this.state.costruttore ?? null),
            Boat_Max_Passengers: (isSoloMotore) ? null : (this.state.trasportati ?? null),

            Boat_kW: this.state.kw ?? null,
            Boat_Fiscal_Power: this.state.cavalli ?? null,
            Boat_Engine_Serial_Number: this.state.matricola ?? null,
            Boat_Engine_Construction_Year: this.state.anno ?? null,
            Boat_Engine_Supply: this.state.alimentazione ?? null,
            Boat_Brand: this.state.marca ?? null,
            Boat_Station_Region: this.state.ormeggio ?? null,

            Boat_Main_Usage: this.state.utilizzo ?? null
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    shipUpdate (this.state)
                )
            }
        )
    }


    // specifici
    private updateTipo (val : string | undefined) {
        this.saveStateAndRedux({
            tipoPolizza: val,
            tipoPolizzaError: undefined
        })
    }
    private updateLunghezza (val : string | undefined) {
        this.saveStateAndRedux({
            lunghezza: val ? Number(val) : undefined,
            lunghezzaError: undefined
        })
    }
    private updatePeso (val: string | undefined) {
        this.saveStateAndRedux({
            peso: val ? Number(val) : undefined,
            pesoError: undefined
        })
    }
    private updateTarga (val: string | undefined) {
        this.saveStateAndRedux({
            targa: val,
            targaError: undefined
        })
    }
    private updateNome (val: string | undefined) {
        this.saveStateAndRedux({
            nome: val,
            nomeError: undefined
        })
    }
    private updatePorto (val: string | undefined) {
        this.saveStateAndRedux({
            porto: val,
            portoError: undefined
        })
    }
    private updateCostruttore (val: string | undefined) {
        this.saveStateAndRedux({
            costruttore: val,
            costruttoreError: undefined
        })
    }
    private updateTrasportati (val: string | undefined) {
        this.saveStateAndRedux({
            trasportati: val ? Number(val) : undefined,
            trasportatiError: undefined
        })
    }

    private updateKw (val: string | undefined) {
        const kw = (val && val.length > 38) ? val.slice(0,38) : val

        this.saveStateAndRedux ({
            kw: kw,
            kwError: undefined
        })
    }
    private updateCavalli (val: string | undefined) {
        const cavalli = (val && val.length > 38) ? val.slice(0,38) : val

        this.saveStateAndRedux ({
            cavalli: cavalli,
            cavalliError: undefined
        })
    }
    private updateMatricola (val: string | undefined) {
        this.saveStateAndRedux ({
            matricola: val,
            matricolaError: undefined
        })
    }
    private updateAnno (val: string | undefined) {
        const anno = (val && val.length > 4) ? val.slice(0,4) : val

        this.saveStateAndRedux ({
            anno: anno,
            annoError: undefined
        })
    }
    private updateAlimentazione (val: string | undefined) {
        this.saveStateAndRedux ({
            alimentazione: val,
            alimentazioneError: undefined
        })
    }
    private updateMarca (val: string | undefined) {
        this.saveStateAndRedux ({
            marca: val,
            marcaError: undefined
        })
    }
    private updateOrmeggio (val: string | undefined) {
        this.saveStateAndRedux ({
            ormeggio: val,
            ormeggioError: undefined
        })
    }
    
    private updateUtilizzo (val: string | undefined) {
        this.saveStateAndRedux ({
            utilizzo: val,
            utilizzoError: undefined
        })
    }

    private updateAlimentizioni (resp: any) {
        this.setState ({
            alimentazioni: resp
        })
    }
    private updateTipologie (resp: any) {
        this.setState ({
            tipologie: resp
        })
    }
    private updateUtilizzi  (resp: any) {
        this.setState ({
            utilizzi: resp
        })
    }
    private updateLuoghi (resp: any) {
        this.setState ({
            luoghi: resp
        })
    }

    
    private stepTwoValidation () {
        let error = ShipValidation.pageTwoValidation (
            this.state.altriSinistri,
            this.state.polizzaAttiva,
            this.state.scadenzaPolizza,
            this.state.tipoPolizza,
            this.state.lunghezza,
            this.state.peso,
            this.state.targa,
            this.state.nome,
            this.state.porto,
            this.state.costruttore,
            this.state.trasportati,
            this.printError,
            this.manageExpiredSessions
        )

        return error
    }
    private stepThreeValidation () {
        let error = ShipValidation.pageThreeValidation (
            this.state.kw,
            this.state.cavalli,
            this.state.matricola,
            this.state.anno,
            this.state.alimentazione,
            this.state.marca,
            this.state.ormeggio,
            this.state.utilizzo,

            this.state.user,
            getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),

            this.printError,
            this.manageExpiredSessions
        )

        return error
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipoPolizza: state.tipoPolizza,
    lunghezza: state.lunghezza,
    peso: state.peso,
    targa: state.targa,
    nome: state.nome,
    porto: state.porto,
    costruttore: state.costruttore,
    trasportati: state.trasportati,

    kw: state.kw,
    cavalli: state.cavalli,
    matricola: state.matricola,
    anno: state.anno,
    alimentazione: state.alimentazione,
    marca: state.marca,
    ormeggio: state.ormeggio,
    utilizzo: state.utilizzo,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user,
  }
}

export default connect(mapState) (ShipPage)